import React from "react";
import FooterList from "../components/Footer/FooterList";
import FooterCopyright from "../components/Footer/FooterCopyright";
import Image from "../components/Common/Images/Image";
import logo from '../Assets/Images/logo.png';

const FooterTemplate = () => {
  const employerLinks = [
    { text: "Browse Candidates", href: "candidates-listing.html" },
    { text: "Employer Dashboard", href: "dashboard.html" },
    { text: "Job Packages", href: "dashboard-packages.html" },
    { text: "Jobs Featured", href: "job-listing.html" },
    { text: "Post A Job", href: "post-job.html" },
  ];

  const candidateLinks = [
    { text: "Browse Jobs", href: "job-listing.html" },
    { text: "Submit Resume", href: "dashboard-submit-resume.html" },
    { text: "Candidates Dashboard", href: "dashboard.html" },
    { text: "Browse Categories", href: "job-listing.html" },
    { text: "Candidate Listing", href: "candidates-listing.html" },
  ];

  const companyLinks = [
    { text: "About Us", href: "about.html" },
    { text: "Contact Us", href: "contact.html" },
    { text: "Terms & Conditions", href: "terms-condition.html" },
    { text: "Privacy Policy", href: "privacy-policy.html" },
    { text: "Candidate Listing", href: "candidates-listing.html" },
  ];

  const quickLinks = [
    { text: "Jobs Listing", href: "job-listing.html" },
    { text: "Employer Listing", href: "employers-listing.html" },
    { text: "Post New Job", href: "post-job.html" },
    { text: "All Employers", href: "employers-listing.html" },
    { text: "Featured Jobs", href: "job-listing.html" },
  ];

  return (
    <footer className="footer-area">
      {/* <div className="container">
        <div className="footer-top pt-100 pb-70">
          <div className="row">
            <div className="col-lg-3 col-sm-6 col-md-6">
              <div className="footer-widget">
                <div className="footer-logo">
                  <a href="index.html">
                    <Image
                      src={logo}
                      className="footer-logo1"
                      alt="Footer Logo"
                    />
                  </a>
                </div>

                <ul className="footer-contact-list">
                  <li>
                    <i className="ri-map-pin-line"></i>
                    <div className="content">
                      <a
                        href="https://goo.gl/maps/muUSCY6FnusqhrGK9"
                        target="_blank"
                      >
                        328 Queensberry Street, North Melbourne VIC
                      </a>
                    </div>
                  </li>
                  <li>
                    <i className="ri-mail-line"></i>
                    <div className="content">
                      <a href="/cdn-cgi/l/email-protection#90f8f5fcfcffd0eafff2f5febef3fffd">
                        <span
                          className="__cf_email__"
                          data-cfemail="fe969b929291be84919c9b90d09d9193"
                        >
                          [email protected]
                        </span>
                      </a>
                    </div>
                  </li>
                  <li>
                    <i className="ri-phone-line"></i>
                    <div className="content">
                      <a href="tel:4471234567890">+44 4325 9878 5875</a>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-lg-2 col-sm-6 col-md-6">
              <FooterList heading="For Employer" items={employerLinks} />
            </div>

            <div className="col-lg-3 col-sm-6 col-md-4">
              <FooterList heading="For Canditates" items={candidateLinks} />
            </div>

            <div className="col-lg-2 col-sm-6 col-md-4">
              <FooterList heading="Company" items={companyLinks} />
            </div>

            <div className="col-lg-2 col-sm-6 col-md-4">
              <FooterList heading="Quick Links" items={quickLinks} />
            </div>
          </div>
        </div>
      </div> */}
      <FooterCopyright />
    </footer>
  );
};

export default FooterTemplate;
